import addClass from '../../general/class/addClass';
import child from '../../general/child';
import removeClass from '../../general/class/removeClass';

import { toastSource } from './source';

// ----------------------------------------------------------------------------

export type TypeChangeConfig = {
    type?: string;
    title?: string | HTMLElement;
    message?: string | HTMLElement;
    placement?: string;
};

// ----------------------------------------------------------------------------

function change(element: HTMLElement, config: TypeChangeConfig = {}): void {
    // If using type
    if (config.type && typeof config.type === 'string') {
        changeType(element, config.type);
    }

    // If using title
    if (config.title != null) {
        changeTitle(element, config.title);
    }

    // If using message
    if (config.message != null) {
        changeMessage(element, config.message);
    }

    // If using placement
    if (config.placement && typeof config.placement === 'string') {
        changePlacement(element, config.placement);
    }
}

// ----------------------------------------------------------------------------

function changeType(element: HTMLElement, type: string): void {
    // Remove class type of toast
    removeClass(element, Object.values(toastSource.color).join(' '));
    // Add class type of toast
    addClass(element, toastSource.color[type]);
}

function changeTitle(element: HTMLElement, title: string | HTMLElement): void {
    // Get element (toast header)
    const elToastHeader = element.querySelector<HTMLElement>('.toast-header');
    // If there is element (toast header)
    if (elToastHeader) {
        child(elToastHeader, title);
    }
}

function changeMessage(element: HTMLElement, message: string | HTMLElement): void {
    // Get element (toast body)
    const elToastBody = element.querySelector<HTMLElement>('.toast-body');
    // If there is element (toast body)
    if (elToastBody) {
        child(elToastBody, message);
    }
    // Is default
    else {
        element.child(message);
    }
}

function changePlacement(element: HTMLElement, placement: string): void {
    // Get toast container
    const elToastContainer = element.parentElement;
    // If there is toast container
    if (elToastContainer && elToastContainer.classList.contains('toast-container')) {
        // Remove class placement of toast container
        removeClass(elToastContainer, Object.values(toastSource.placement).join(' '));
        // Add class placement of toast container
        addClass(elToastContainer, toastSource.placement[placement]);
    }
}

// ----------------------------------------------------------------------------

export { change, changeType, changeTitle, changeMessage, changePlacement };
